module.exports = __webpack_public_path__ + "fonts/iconfont.37898604.woff";